export const validationHistory = [
    { id: 1, date: "2024-11-20", pieceName: "Pièce A", operator: "Jean Dupont", status: "Validée" },
    { id: 2, date: "2024-11-21", pieceName: "Pièce B", operator: "Marie Curie", status: "Rejetée" },
    { id: 3, date: "2024-11-22", pieceName: "Pièce C", operator: "Paul Martin", status: "Validée" },
    { id: 4, date: "2024-11-23", pieceName: "Pièce D", operator: "Alice Doe", status: "Validée" },
    { id: 5, date: "2024-11-24", pieceName: "Pièce E", operator: "Jean Dupont", status: "Rejetée" },
    { id: 6, date: "2024-11-25", pieceName: "Pièce F", operator: "Marie Curie", status: "Validée" },
];
